import { buttonCoreDriverFactory } from '../Button/ButtonCore/ButtonCore.uni.driver';
import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const closeButtonDriverFactory = base => {
  const buttonDriver = buttonCoreDriverFactory(base);

  return {
    ...baseUniDriverFactory(base),
    /** Checks whether the button is disabled
     * @returns {Promise<boolean>}
     * */
    isButtonDisabled: buttonDriver.isButtonDisabled,
  };
};
